<template>
  <svg
    v-if="iconName == 'AddUser'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12V14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C13.0912 2 14.1172 2.29221 15.0007 2.80331L13.9993 4.53452C13.4119 4.19477 12.7302 4 12 4Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M12.0001 17C8.13088 17 4.90125 19.7478 4.1601 23.3989L2.20007 23.0011C3.1267 18.4362 7.16097 15 12.0001 15C16.8391 15 20.8734 18.4362 21.8 23.0011L19.84 23.3989C19.0989 19.7478 15.8692 17 12.0001 17Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M18 4V8H22V10H18V14H16V10H12V8H16V4H18Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Alert'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 10C6 7.027 8.16229 4.55904 11 4.08296V2H13V4.08296C15.8377 4.55904 18 7.027 18 10V13.6972L19.8321 16.4453C20.0366 16.7522 20.0557 17.1467 19.8817 17.4719C19.7077 17.797 19.3688 18 19 18H5C4.63121 18 4.29235 17.797 4.11833 17.4719C3.94431 17.1467 3.96338 16.7522 4.16795 16.4453L6 13.6972V10ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V14C16 14.1974 16.0584 14.3904 16.168 14.5547L17.1315 16H6.86852L7.83205 14.5547C7.94156 14.3904 8 14.1974 8 14V10Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M14 19C13.9999 20.1045 13.1045 21 12 21C10.8954 21 9.99997 20.1045 9.99997 19H14Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Apps'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 3C2 2.44772 2.44772 2 3 2H9C9.55228 2 10 2.44772 10 3V9C10 9.55228 9.55228 10 9 10H3C2.44772 10 2 9.55228 2 9V3ZM4 8V4H8V8H4Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 14C2.44772 14 2 14.4477 2 15V21C2 21.5523 2.44772 22 3 22H9C9.55228 22 10 21.5523 10 21V15C10 14.4477 9.55228 14 9 14H3ZM4 16V20H8V16H4Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 14C14.4477 14 14 14.4477 14 15V21C14 21.5523 14.4477 22 15 22H21C21.5523 22 22 21.5523 22 21V15C22 14.4477 21.5523 14 21 14H15ZM16 16V20H20V16H16Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M17 2H19V5H22V7H19V10H17V7H14V5H17V2Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ArrowDown'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5857 16.0606L3.29285 8.76773L4.70706 7.35352L12 14.6464L19.2928 7.35352L20.7071 8.76773L13.4142 16.0606C12.6331 16.8417 11.3668 16.8417 10.5857 16.0606Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ArrowLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.93925 10.5856L15.2321 3.29272L16.6464 4.70694L9.35347 11.9998L16.6464 19.2927L15.2321 20.7069L7.93926 13.414C7.15821 12.633 7.15821 11.3667 7.93925 10.5856Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ArrowRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.0607 13.4141L8.76785 20.707L7.35364 19.2928L14.6465 11.9999L7.35364 4.70703L8.76785 3.29282L16.0607 10.5857C16.8418 11.3668 16.8418 12.6331 16.0607 13.4141Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ArrowUp'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5859 7.93938L3.29297 15.2323L4.70718 16.6465L12.0001 9.35359L19.293 16.6465L20.7072 15.2323L13.4143 7.93938C12.6332 7.15833 11.3669 7.15833 10.5859 7.93938Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Attachment'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.12135 18.6776C1.16873 16.725 1.16873 13.5592 3.12135 11.6066L10.1924 4.53549C12.9261 1.80182 17.3582 1.80182 20.0919 4.53549C22.8256 7.26916 22.8256 11.7013 20.0919 14.435L13.728 20.7989L12.3137 19.3847L18.6777 13.0208C20.6303 11.0681 20.6303 7.90232 18.6777 5.9497C16.7251 3.99708 13.5593 3.99708 11.6066 5.9497L4.53556 13.0208C3.36399 14.1923 3.36399 16.0918 4.53556 17.2634C5.70714 18.435 7.60663 18.435 8.7782 17.2634L15.8493 10.1923C16.2398 9.80182 16.2398 9.16865 15.8493 8.77813C15.4587 8.3876 14.8256 8.3876 14.4351 8.77813L7.36399 15.8492L5.94978 14.435L13.0208 7.36392C14.1924 6.19234 16.0919 6.19234 17.2635 7.36392C18.4351 8.53549 18.4351 10.435 17.2635 11.6066L10.1924 18.6776C8.2398 20.6302 5.07397 20.6302 3.12135 18.6776Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'avito'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#E9EDF2"
    />
    <path
      d="M19 15C19 17.2091 17.2091 19 15 19C12.7909 19 11 17.2091 11 15C11 12.7909 12.7909 11 15 11C17.2091 11 19 12.7909 19 15Z"
      fill="#00B336"
    />
    <path
      d="M11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5Z"
      fill="#0075DB"
    />
    <path
      d="M16.4627 8.073C16.4627 9.17757 15.5673 10.073 14.4627 10.073C13.3581 10.073 12.4627 9.17757 12.4627 8.073C12.4627 6.96843 13.3581 6.073 14.4627 6.073C15.5673 6.073 16.4627 6.96843 16.4627 8.073Z"
      fill="#EE1C1C"
    />
    <path
      d="M10 15C10 15.8284 9.32843 16.5 8.5 16.5C7.67157 16.5 7 15.8284 7 15C7 14.1716 7.67157 13.5 8.5 13.5C9.32843 13.5 10 14.1716 10 15Z"
      fill="#BD50F9"
    />
  </svg>
  <svg
    v-else-if="iconName == 'BarGraph'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM21 5H3V19H21V5ZM7 8V17H5V8H7ZM19 8V17H17V8H19ZM11 10V17H9V10H11ZM15 14V17H13V14H15Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Bookmark'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 14.5585L17 18.12V5L7.00002 5L7 18.12L12 14.5585ZM12 17.014L17.4199 20.8745C18.0819 21.346 19 20.8727 19 20.06V4C19 3.44772 18.5523 3 18 3L6.00002 3C5.44774 3 5.00002 3.44772 5.00002 4L5 20.06C5 20.8727 5.91816 21.346 6.58016 20.8745L12 17.014Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'BoxDownload'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5 3H17.5L21 7.66667V21H3V7.66667L6.5 3ZM5 9V19H19V9H5ZM16 5H8V7H16V5ZM13 11V14H15.4142L12 17.4142L8.58579 14H11L11 11H13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Building'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 1H15V9H17V7H19V9H23V23H17V19H15V23H9V19H7V23H1V1ZM7 17H9V15H7V17ZM5 15V17H3V15H5ZM7 13H9V11H7V13ZM5 11V13H3V11H5ZM7 9H9V7H7V9ZM5 7V9H3V7H5ZM7 5H9V3H7V5ZM5 3V5H3V3H5ZM11 3V5H13V3H11ZM13 7H11V9H13V7ZM13 11H11V13H13V11ZM13 15H11V17H13V15ZM15 17H19V21H21V11H15V17ZM13 19H11V21H13V19ZM3 19H5V21H3V19ZM17 15V13H19V15H17Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Cake'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C13.11 6 14 5.1 14 4C14 3.62 13.9 3.27 13.71 2.97L12 0L10.29 2.97C10.1 3.27 10 3.62 10 4C10 5.1 10.9 6 12 6ZM18 9H13V7H11V9H6C4.34 9 3 10.34 3 12V21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21V12C21 10.34 19.66 9 18 9ZM19 20H5V17C5.9 16.99 6.76 16.63 7.4 15.99L8.49 14.92L9.56 15.99C10.87 17.3 13.15 17.29 14.45 15.99L15.53 14.92L16.6 15.99C17.24 16.63 18.1 16.99 19 17V20ZM19 15.5C18.49 15.49 18.01 15.3 17.65 14.93L15.52 12.8L13.38 14.93C12.64 15.67 11.35 15.67 10.61 14.93L8.48 12.8L6.34 14.93C5.99 15.29 5.51 15.49 5 15.5V12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12V15.5Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CalendarAdd'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18V1H16V3H8V1H6V3ZM4 5V7.95H20V5L4 5ZM20 9.95H4V20H20V9.95ZM11 16V19H13V16H16V14H13V11H11V14H8V16H11Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CalendarEvent'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18V1H16V3H8V1H6V3ZM4 5V7.95H20V5L4 5ZM20 9.95H4V20H20V9.95ZM13 13H18V18H13V13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CalendarText'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 3H4C2.89543 3 2 3.89543 2 5V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V5C22 3.89543 21.1046 3 20 3H18V1H16V3H8V1H6V3ZM4 5V7.95H20V5L4 5ZM20 9.95H4V20H20V9.95ZM18 14H6V12H18V14ZM18 18H6V16H18V18Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CircleAdd'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM11 11V8H13V11H16V13H13V16H11V13H8V11H11Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CircleCross'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13.4142 12L16.7071 8.70711L15.2929 7.29289L12 10.5858L8.70711 7.29289L7.29289 8.70711L10.5858 12L7.29289 15.2929L8.70711 16.7071L12 13.4142L15.2929 16.7071L16.7071 15.2929L13.4142 12Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CircleOk'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6783 9.7348C18.0841 9.3602 18.1094 8.72754 17.7348 8.32172C17.3602 7.9159 16.7275 7.89059 16.3217 8.2652L10.5277 13.6135L8.70711 11.7929C8.31658 11.4024 7.68342 11.4024 7.29289 11.7929C6.90237 12.1834 6.90237 12.8166 7.29289 13.2071L10.4723 16.3865L17.6783 9.7348Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CircleQuestion'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0348 7.49829C10.7769 7.49829 9.68835 8.4845 9.68835 9.79889H7.68835C7.68835 7.28566 9.769 5.49829 12.0348 5.49829C14.3288 5.49829 16.3094 7.31299 16.3094 9.79889C16.3094 10.8843 15.8307 11.6072 15.277 12.1761C15.0623 12.3967 14.8182 12.6123 14.596 12.8084C14.5542 12.8453 14.5131 12.8816 14.4732 12.9171C14.2076 13.153 13.9549 13.3851 13.7129 13.6526C13.5073 13.8799 13.3299 14.2057 13.2039 14.5526C13.0741 14.9097 13.0348 15.1884 13.0348 15.2804H11.0348C11.0348 14.8812 11.1449 14.3629 11.3241 13.8697C11.5069 13.3663 11.7979 12.7883 12.2298 12.3108C12.5478 11.9594 12.8673 11.6684 13.1451 11.4217C13.1946 11.3777 13.242 11.3358 13.2875 11.2956C13.5097 11.0991 13.6865 10.9428 13.8437 10.7813C14.179 10.4366 14.3094 10.187 14.3094 9.79889C14.3094 8.45717 13.2643 7.49829 12.0348 7.49829ZM11.0348 18.5V16.5H13.0348V18.5H11.0348ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'CircleWarning'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 6V14H13V6H11Z" :fill="iconColor || 'black'" />
    <path d="M11 16L11 18H13L13 16H11Z" :fill="iconColor || 'black'" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751
    23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23
    5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3
    7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Clock'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 12.4142V5H13V11.5858L16.7071 15.2929L15.2929 16.7071L11 12.4142ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Copy'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Cross'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 13.4142L7.0502 18.3639L5.63599 16.9497L10.5857 11.9999L5.63599 7.0502L7.0502 5.63599L11.9999 10.5857L16.9497 5.63599L18.3639 7.0502L13.4142 11.9999L18.3639 16.9497L16.9497 18.3639L11.9999 13.4142Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'DelUser'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 7C8 4.79086 9.79086 3 12 3C13.0905 3 14.0774 3.43508 14.8 4.14338C15.148 4.48458 15.4336 4.8883 15.6386 5.33559L17.4567 4.50223C17.1486 3.82999 16.7204 3.22528 16.2 2.71518C15.1188 1.65524 13.6349 1 12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13C13.3498 13 14.5982 12.5531 15.6012 11.7995L14.3998 10.2005C13.7313 10.7028 12.9018 11 12 11C9.79086 11 8 9.20914 8 7Z"
      :fill="iconColor || 'black'"
    />
    <path d="M22 7H12V9H22V7Z" :fill="iconColor || 'black'" />
    <path
      d="M4.1601 22.3989C4.90125 18.7478 8.13088 16 12.0001 16C15.8692 16 19.0989 18.7478 19.84 22.3989L21.8 22.0011C20.8734 17.4362 16.8391 14 12.0001 14C7.16097 14 3.1267 17.4362 2.20007 22.0011L4.1601 22.3989Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'DeleteForever'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.44721 3.10557L8 4H5C4.44772 4 4 4.44772 4 5V6H20V5C20 4.44772 19.5523 4 19 4H16L15.5528 3.10557C15.5348 3.06967 15.5159 3.03447 15.496 3C15.1404 2.38385 14.4813 2 13.7639 2H10.2361C9.51866 2 8.85957 2.38385 8.504 3C8.48411 3.03447 8.46516 3.06967 8.44721 3.10557Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M14.2929 18.7071L12 16.4142L9.70711 18.7071L8.29289 17.2929L10.5858 15L8.29289 12.7071L9.70711 11.2929L12 13.5858L14.2929 11.2929L15.7071 12.7071L13.4142 15L15.7071 17.2929L14.2929 18.7071Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 20V8H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20ZM7 20V10H17V20H7Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Descending'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 7H5V5H19V7ZM19 11H8V9H19V11ZM19 15H11V13H19V15ZM19 19H14V17H19V19Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Diamond'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.58582 4H17.4142L23.4142 10L12 21.4142L0.585815 10L6.58582 4ZM7.41424 6L4.41424 9H6.58582L9.58582 6H7.41424ZM12 6.41421L9.41424 9H14.5858L12 6.41421ZM15.382 11H8.61806L12 17.7639L15.382 11ZM8.34975 14.9355L6.382 11H4.41424L8.34975 14.9355ZM15.6503 14.9355L17.6181 11H19.5858L15.6503 14.9355ZM19.5858 9H17.4142L14.4142 6H16.5858L19.5858 9Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Document'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8L20 20C20 21.1046 19.1046 22 18 22L6 22C4.89543 22 4 21.1046 4 20L4 4C4 2.89543 4.89543 2 6 2L14 2C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289ZM18 20L18 9L13 9L13 4L6 4L6 20L18 20ZM15 5.41421L15 7L16.5858 7L15 5.41421Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'DoubleSmallArrowLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2387 6.29297L12.6529 7.70718L8.36004 12.0001L12.6529 16.293L11.2387 17.7072L5.53162 12.0001L11.2387 6.29297Z"
      :fill="iconColor || '#21272C'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0543 6.29298L18.4685 7.7072L14.1756 12.0001L18.4685 16.293L17.0543 17.7072L11.3472 12.0001L17.0543 6.29298Z"
      :fill="iconColor || '#21272C'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'DoubleSmallArrowRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7613 6.29297L11.347 7.70718L15.6399 12.0001L11.347 16.293L12.7613 17.7072L18.4684 12.0001L12.7613 6.29297Z"
      :fill="iconColor || '#21272C'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.94571 6.29298L5.53149 7.7072L9.82439 12.0001L5.53149 16.293L6.94571 17.7072L12.6528 12.0001L6.94571 6.29298Z"
      :fill="iconColor || '#21272C'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Download'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 2H16V13H19L12 18.25L5 13H8V2ZM10 14.25L12 15.75L14 14.25V4H10V14.25ZM21 20V22H3V20H21Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Drag'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#E9EDF2" />
    <path d="M6 6H18V8H6V6Z" fill="#99A5B3" />
    <path d="M6 11H18V13H6V11Z" fill="#99A5B3" />
    <path d="M6 16H18V18H6V16Z" fill="#99A5B3" />
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#DADFE4" />
  </svg>
  <svg
    v-else-if="iconName == 'Duitcase'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4V6H20C21.6569 6 23 7.34315 23 9V19C23 20.6569 21.6569 22 20 22H4C2.34315 22 1 20.6569 1 19V9C1 7.34315 2.34315 6 4 6H7V4ZM9 6H15V4H9V6ZM4 8C3.44772 8 3 8.44772 3 9V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V9C21 8.44772 20.5523 8 20 8H4Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 15H9V13H15V15Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Duplicate'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 4C3 2.89543 3.89543 2 5 2L11 2C11.2387 2 11.4695 2.08539 11.6508 2.24074L14.8699 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289L20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V21C21 22.1046 20.1046 23 19 23H9C8.25972 23 7.61337 22.5978 7.26757 22H5C3.89543 22 3 21.1046 3 20L3 4ZM7 20L7 7C7 5.89543 7.89543 5 9 5H11.7967L10.6301 4L5 4L5 20H7ZM14 7H9L9 21H19V12H14V7ZM17.5858 10H16V8.41421L17.5858 10Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Enter'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 4C2 2.89543 2.89543 2 4 2L12 2V4L4 4L4 20H12V22H4C2.89543 22 2 21.1046 2 20L2 4ZM11.4142 13L14.7071 16.2929L13.2929 17.7071L7.58579 12L13.2929 6.29289L14.7071 7.70711L11.4142 11L21 11V13L11.4142 13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Exit'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 21L4 22H4V21ZM3 20H4H3ZM3 4L2 4L3 4ZM4 3L4 4L4 3ZM21 12L21.7071 12.7071L22.4142 12L21.7071 11.2929L21 12ZM12 20H4V22H12V20ZM4 20L4 4L2 4L2 20H4ZM4 4L12 4V2L4 2L4 4ZM4 4H4L4 2C2.89543 2 2 2.89543 2 4L4 4ZM4 20H2C2 21.1046 2.89543 22 4 22L4 20ZM9 13L21 13V11L9 11V13ZM21.7071 11.2929L16.7071 6.29289L15.2929 7.70711L20.2929 12.7071L21.7071 11.2929ZM20.2929 11.2929L15.2929 16.2929L16.7071 17.7071L21.7071 12.7071L20.2929 11.2929Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'EyeCrossed'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.22907 4.23682L19.7283 19.736L19.7307 19.7337L19.7315 19.7344L18.3172 21.1486L15.6455 18.4769C14.4986 18.8164 13.2731 19 12 19C6.92156 19 2.60118 16.0782 1 12C1.7114 10.1881 2.95956 8.60444 4.57249 7.40389L2.81725 5.64864L4.22907 4.23682ZM13.989 16.8204L13.0337 15.8651C12.704 15.9531 12.3575 16 12 16C9.79086 16 8 14.2091 8 12C8 11.6425 8.04689 11.296 8.13486 10.9663L6.00522 8.83662C4.79433 9.68295 3.82736 10.7727 3.19322 12C4.68044 14.8784 7.99829 17 12 17C12.6849 17 13.3499 16.9379 13.989 16.8204Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M8.3462 5.52552L10.002 7.1813C10.6439 7.06275 11.3118 7.00001 12 7.00001C16.0017 7.00001 19.3196 9.12161 20.8068 12C20.1715 13.2295 19.2023 14.3208 17.9885 15.1678L19.4214 16.6007C21.0373 15.3996 22.2877 13.8142 23 12C21.3988 7.92183 17.0784 5.00001 12 5.00001C10.7238 5.00001 9.49552 5.18452 8.3462 5.52552Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M15.8629 13.0422C15.9523 12.7099 16 12.3605 16 12C16 9.79087 14.2091 8.00001 12 8.00001C11.6395 8.00001 11.2901 8.0477 10.9578 8.13713C11.0328 8.20176 15.7982 12.9672 15.8629 13.0422Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'EyeOpen'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 19C17.0784 19 21.3988 16.0782 23 12C21.3988 7.92183 17.0784 5 12 5C6.92156 5 2.60118 7.92183 1 12C2.60118 16.0782 6.92156 19 12 19ZM12 17C7.99829 17 4.68044 14.8784 3.19322 12C4.68044 9.12161 7.99829 7 12 7C16.0017 7 19.3196 9.12161 20.8068 12C19.3196 14.8784 16.0017 17 12 17Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Filter'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 5.04664C3 3.91631 3.89543 3 5 3H19C20.1046 3 21 3.91631 21 5.04664V6.29264C21 6.87723 20.7557 7.43393 20.3287 7.82232L15 12.6694V16.9026C15 17.4454 14.7893 17.966 14.4142 18.3498L12.4142 20.3965C11.1543 21.6858 9 20.7726 9 18.9493V12.6694L3.67127 7.82232C3.2443 7.43393 3 6.87723 3 6.29264V5.04664ZM19 5.04664L5 5.04664V6.29264L10.3287 11.1397C10.7557 11.5281 11 12.0848 11 12.6694V18.9493L13 16.9026V12.6694C13 12.0848 13.2443 11.5281 13.6713 11.1397L19 6.29264V5.04664Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Forward'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 8.83L17.17 12L14 15.17V14H6V10H14V8.83ZM12 4V8H4V16H12V20L20 12L12 4Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Frame'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.565V8.1C15 7.54772 14.5523 7.1 14 7.1H12.3333M15 10.565H3M15 10.565V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V10.565M3 10.565V8.1C3 7.54772 3.44772 7.1 4 7.1H5.66667M5.66667 7.1V5M5.66667 7.1H12.3333M12.3333 7.1V5M10.3333 15.15V14.1H12.3333V15.15M10.3333 15.15V16.2H12.3333V15.15M10.3333 15.15H12.3333"
      :stroke="iconColor || '#21272C'"
      stroke-width="2"
    />
    <path d="M16 7L11 12L16 17H18V7H16Z" fill="white" />
    <path
      d="M16.4464 12.3536L19.6929 15.6L19 16.2929L14.7071 12L19 7.70711L19.6929 8.4L16.4464 11.6464L16.0929 12L16.4464 12.3536Z"
      :fill="iconColor || 'black'"
      :stroke="iconColor || '#21272C'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'FullArrowLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 18.207L11.6642 16.7928L7.87127 12.9999L19.9571 12.9999V10.9999L7.87127 10.9999L11.6642 7.20703L10.25 5.79282L4.04285 11.9999L10.25 18.207Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'FullArrowRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.75 5.79297L12.3358 7.20718L16.1287 11.0001H4.04294V13.0001H16.1287L12.3358 16.793L13.75 18.2072L19.9572 12.0001L13.75 5.79297Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Globe'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.8676 19.5683C12.5184 19.9007 12.2269 20 12 20C11.7731 20 11.4816 19.9007 11.1324 19.5683C10.778 19.2311 10.4134 18.6958 10.0854 17.9578C9.82002 17.3607 9.59148 16.6599 9.41351 15.879C10.2399 15.9582 11.1078 16 12 16C12.8922 16 13.7601 15.9582 14.5865 15.879C14.4085 16.6599 14.18 17.3607 13.9146 17.9578C13.5866 18.6958 13.222 19.2311 12.8676 19.5683ZM14.9126 13.8327C14.0101 13.9402 13.0297 14 12 14C10.9703 14 9.98986 13.9402 9.08742 13.8327C9.03043 13.2456 9 12.6325 9 12C9 11.3675 9.03043 10.7544 9.08742 10.1673C9.98986 10.0598 10.9703 10 12 10C13.0297 10 14.0101 10.0598 14.9126 10.1673C14.9696 10.7544 15 11.3675 15 12C15 12.6325 14.9696 13.2456 14.9126 13.8327ZM16.6883 15.5808C16.4726 16.7684 16.151 17.8504 15.7422 18.7701C15.682 18.9057 15.6194 19.0388 15.5544 19.169C17.3773 18.2635 18.8058 16.6831 19.5131 14.7548C19.2483 14.8687 18.9694 14.9736 18.6802 15.07C18.0814 15.2696 17.412 15.4412 16.6883 15.5808ZM20 12.0001C20 12.001 20 12.0052 19.9969 12.0153C19.9935 12.0264 19.9852 12.0485 19.9649 12.0814C19.9225 12.1506 19.8359 12.2545 19.6738 12.3823C19.3436 12.6425 18.8038 12.9206 18.0477 13.1726C17.7119 13.2846 17.3441 13.3879 16.9487 13.4807C16.9826 12.9965 17 12.502 17 12C17 11.498 16.9826 11.0035 16.9487 10.5193C17.3441 10.6121 17.7119 10.7154 18.0477 10.8274C18.8038 11.0794 19.3436 11.3575 19.6738 11.6177C19.8359 11.7455 19.9225 11.8494 19.9649 11.9186C19.9852 11.9515 19.9935 11.9736 19.9969 11.9847C19.9999 11.9943 20 11.9989 20 12.0001ZM16.6883 8.41923C17.412 8.55875 18.0814 8.73039 18.6802 8.93C18.9694 9.02641 19.2483 9.13134 19.5131 9.24521C18.8058 7.31687 17.3773 5.73653 15.5544 4.83099C15.6194 4.96122 15.682 5.09431 15.7422 5.2299C16.151 6.14962 16.4726 7.23161 16.6883 8.41923ZM4 11.9997C4.00001 11.9985 4.00016 11.9942 4.00306 11.9847C4.00645 11.9736 4.01483 11.9515 4.03507 11.9186C4.07752 11.8494 4.16408 11.7455 4.32624 11.6177C4.65642 11.3575 5.19616 11.0794 5.95227 10.8274C6.28815 10.7154 6.65587 10.6121 7.05132 10.5193C7.01744 11.0035 7 11.498 7 12C7 12.502 7.01744 12.9965 7.05132 13.4807M7.31175 15.5808C6.58797 15.4412 5.91863 15.2696 5.31981 15.07C5.03058 14.9736 4.7517 14.8687 4.48695 14.7548C5.19422 16.6831 6.62271 18.2635 8.44561 19.169C8.38064 19.0388 8.31802 18.9057 8.25776 18.7701C7.849 17.8504 7.5274 16.7684 7.31175 15.5808ZM7.31175 8.41923C6.58797 8.55875 5.91863 8.73039 5.31981 8.93C5.03057 9.02641 4.7517 9.13134 4.48695 9.24521C5.19422 7.31687 6.62271 5.73653 8.44561 4.83099C8.38064 4.96122 8.31802 5.09431 8.25776 5.2299C7.849 6.14962 7.5274 7.23161 7.31175 8.41923ZM9.41351 8.12097C9.59148 7.34014 9.82002 6.63925 10.0854 6.04218C10.4134 5.30422 10.778 4.76892 11.1324 4.43166C11.4816 4.0993 11.7731 4 12 4C12.2269 4 12.5184 4.0993 12.8676 4.43166C13.222 4.76892 13.5866 5.30422 13.9146 6.04218C14.18 6.63925 14.4085 7.34014 14.5865 8.12097C13.7601 8.04179 12.8922 8 12 8C11.1078 8 10.2399 8.04179 9.41351 8.12097ZM4 11.9997C4 11.9998 4 11.9997 4 11.9997V11.9997Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Grow'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 17H19V19H5V17ZM5 13H16V15H5V13ZM5 9H13V11H5V9ZM5 5H10V7H5V5Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'hash'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.46032 4C8.95674 4 8.53172 4.37446 8.46828 4.87403L8.11895 7.625H5C4.44771 7.625 4 8.07272 4 8.625C4 9.17728 4.44772 9.625 5 9.625H7.86499L7.26181 14.375H5C4.44772 14.375 4 14.8227 4 15.375C4 15.9273 4.44772 16.375 5 16.375H7.00784L6.69051 18.874C6.61464 19.4715 7.08026 20 7.68254 20C8.18612 20 8.61114 19.6255 8.67457 19.126L9.0239 16.375H13.865L13.5476 18.874C13.4718 19.4715 13.9374 20 14.5397 20C15.0433 20 15.4683 19.6255 15.5317 19.126L15.881 16.375H19C19.5523 16.375 20 15.9273 20 15.375C20 14.8227 19.5523 14.375 19 14.375H16.135L16.7382 9.625H19C19.5523 9.625 20 9.17728 20 8.625C20 8.07272 19.5523 7.625 19 7.625H16.9922L17.3095 5.12597C17.3854 4.52849 16.9197 4 16.3175 4C15.8139 4 15.3889 4.37446 15.3254 4.87403L14.9761 7.625H10.135L10.4524 5.12597C10.5282 4.52849 10.0626 4 9.46032 4ZM9.27787 14.375L9.88105 9.625H14.7221L14.119 14.375H9.27787Z"
      :fill="iconColor"
    />
  </svg>

  <svg
    v-else-if="iconName == 'habr'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6069 10.0005V5H8V18.6006H10.6069V13.665C10.6069 12.8363 10.6842 12.2116 10.8389 11.791C10.9997 11.3643 11.2502 11.0457 11.5903 10.8354C11.9305 10.6252 12.3171 10.52 12.75 10.52C13.1273 10.52 13.4396 10.6035 13.687 10.7705C13.9406 10.9313 14.1169 11.1509 14.2158 11.4292C14.3148 11.7075 14.3643 12.3631 14.3643 13.396V18.6006H16.9712V12.8208C16.9712 11.9364 16.9248 11.2839 16.832 10.8633C16.7454 10.4427 16.5785 10.0592 16.3311 9.71289C16.0898 9.36654 15.728 9.08203 15.2456 8.85938C14.7632 8.63672 14.222 8.52539 13.6221 8.52539C12.4531 8.52539 11.4481 9.01709 10.6069 10.0005Z"
      fill="#62717E"
    />
    <path
      d="M10.6069 5V10.0005C11.4481 9.01709 12.4531 8.52539 13.6221 8.52539C14.222 8.52539 14.7632 8.63672 15.2456 8.85938C15.728 9.08203 16.0898 9.36654 16.3311 9.71289C16.5785 10.0592 16.7454 10.4427 16.832 10.8633C16.9248 11.2839 16.9712 11.9364 16.9712 12.8208V18.6006H14.3643V13.396C14.3643 12.3631 14.3148 11.7075 14.2158 11.4292C14.1169 11.1509 13.9406 10.9313 13.687 10.7705C13.4396 10.6035 13.1273 10.52 12.75 10.52C12.3171 10.52 11.9305 10.6252 11.5903 10.8354C11.2502 11.0457 10.9997 11.3643 10.8389 11.791C10.6842 12.2116 10.6069 12.8363 10.6069 13.665V18.6006H8V5H10.6069Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Headset'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10V16.2756C19 16.5369 18.8977 16.7879 18.715 16.9747L15.0734 20.6991C14.8852 20.8915 14.6275 21 14.3584 21H14C14 20.4477 13.5523 20 13 20H11C10.4477 20 10 20.4477 10 21V22C10 22.5523 10.4477 23 11 23H14.3584C15.1657 23 15.939 22.6746 16.5034 22.0974L20.145 18.373C20.6931 17.8124 21 17.0596 21 16.2756V16H22C22.5523 16 23 15.5523 23 15V11C23 10.4477 22.5523 10 22 10H21C21 5.02944 16.9706 1 12 1C7.02944 1 3 5.02944 3 10H2C1.44772 10 1 10.4477 1 11V15C1 15.5523 1.44772 16 2 16H5V10Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'hh'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6069 10.0005V5H8V18.6006H10.6069V13.665C10.6069 12.8363 10.6842 12.2116 10.8389 11.791C10.9997 11.3643 11.2502 11.0457 11.5903 10.8354C11.9305 10.6252 12.3171 10.52 12.75 10.52C13.1273 10.52 13.4396 10.6035 13.687 10.7705C13.9406 10.9313 14.1169 11.1509 14.2158 11.4292C14.3148 11.7075 14.3643 12.3631 14.3643 13.396V18.6006H16.9712V12.8208C16.9712 11.9364 16.9248 11.2839 16.832 10.8633C16.7454 10.4427 16.5785 10.0592 16.3311 9.71289C16.0898 9.36654 15.728 9.08203 15.2456 8.85938C14.7632 8.63672 14.222 8.52539 13.6221 8.52539C12.4531 8.52539 11.4481 9.01709 10.6069 10.0005Z"
      fill="#FC311E"
    />
    <path
      d="M10.6069 5V10.0005C11.4481 9.01709 12.4531 8.52539 13.6221 8.52539C14.222 8.52539 14.7632 8.63672 15.2456 8.85938C15.728 9.08203 16.0898 9.36654 16.3311 9.71289C16.5785 10.0592 16.7454 10.4427 16.832 10.8633C16.9248 11.2839 16.9712 11.9364 16.9712 12.8208V18.6006H14.3643V13.396C14.3643 12.3631 14.3148 11.7075 14.2158 11.4292C14.1169 11.1509 13.9406 10.9313 13.687 10.7705C13.4396 10.6035 13.1273 10.52 12.75 10.52C12.3171 10.52 11.9305 10.6252 11.5903 10.8354C11.2502 11.0457 10.9997 11.3643 10.8389 11.791C10.6842 12.2116 10.6069 12.8363 10.6069 13.665V18.6006H8V5H10.6069Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Home'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 10.8284V20H15V13H9V20H6V10.8284L12 4.82843L18 10.8284ZM12 2L22 12H20V22H13V15H11V22H4V12H2L12 2Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'indeterminate'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2ZM17 11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Link'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7071 4.22181C14.6598 2.26919 17.8256 2.26919 19.7782 4.22181C21.7308 6.17443 21.7308 9.34026 19.7782 11.2929L16.9498 14.1213L15.5356 12.7071L18.364 9.87867C19.5356 8.70709 19.5356 6.8076 18.364 5.63603C17.1924 4.46445 15.2929 4.46445 14.1214 5.63603L11.2929 8.46445L9.87871 7.05024L12.7071 4.22181ZM7.75739 14.8284L14.8285 7.75735L16.2427 9.17156L9.17161 16.2426L7.75739 14.8284ZM4.22186 12.7071L7.05029 9.87867L8.4645 11.2929L5.63607 14.1213C4.4645 15.2929 4.4645 17.1924 5.63607 18.3639C6.80765 19.5355 8.70714 19.5355 9.87871 18.3639L12.7071 15.5355L14.1214 16.9497L11.2929 19.7782C9.34031 21.7308 6.17448 21.7308 4.22186 19.7782C2.26924 17.8255 2.26924 14.6597 4.22186 12.7071Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ListCheck'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.70706 4.70718L6.29285 3.29297L3.99995 5.58586L3.20706 4.79297L1.79285 6.20718L3.99995 8.41429L7.70706 4.70718Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M7.70706 10.7072L6.29285 9.29297L3.99995 11.5859L3.20706 10.793L1.79285 12.2072L3.99995 14.4143L7.70706 10.7072Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M6.29285 15.293L7.70706 16.7072L3.99995 20.4143L1.79285 18.2072L3.20706 16.793L3.99995 17.5859L6.29285 15.293Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M22 5.00008H8.99995V7.00008H22V5.00008Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M8.99995 11.0001H22V13.0001H8.99995V11.0001Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M22 17.0001H8.99995V19.0001H22V17.0001Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ListSharp'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 5H2V7H4V5Z" :fill="iconColor || 'black'" />
    <path d="M22 5H6V7H22V5Z" :fill="iconColor || 'black'" />
    <path d="M22 11H6V13H22V11Z" :fill="iconColor || 'black'" />
    <path d="M6 17H22V19H6V17Z" :fill="iconColor || 'black'" />
    <path d="M2 11H4V13H2V11Z" :fill="iconColor || 'black'" />
    <path d="M4 17H2V19H4V17Z" :fill="iconColor || 'black'" />
  </svg>
  <svg
    v-else-if="iconName == 'Lock'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V11.0045C17.5606 11.055 18 11.5262 18 12.1V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V12.1C6 11.5262 6.43935 11.055 7 11.0045V9ZM9 11H15V9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9V11ZM8 13V18H16V13H8Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MailOpen'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0.88208L22.4472 6.10569C22.786 6.27508 23 6.62134 23 7.00011V20.0001C23 21.1047 22.1046 22.0001 21 22.0001H3C1.89543 22.0001 1 21.1047 1 20.0001V7.00011C1 6.62134 1.214 6.27508 1.55279 6.10569L12 0.88208ZM3 8.61815L12 13.1181L21 8.61815V20.0001H3V8.61815ZM19.7639 7.00011L12 10.8821L4.23607 7.00011L12 3.11815L19.7639 7.00011Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MailClosed'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 4C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H3ZM20.0563 6L3.94365 6L12 10.8338L20.0563 6ZM3 7.76619V18H21V7.76619L12.5145 12.8575L12 13.1662L11.4855 12.8575L3 7.76619Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MailOutgoing'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V11.5H21V7.76619L12 13.1662L3 7.76619V18H12V20H3C1.89543 20 1 19.1046 1 18V6ZM12 10.8338L3.94365 6L20.0563 6L12 10.8338Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M19.7071 13.2929L18.2929 14.7071L19.5858 16H14V18H19.5858L18.2929 19.2929L19.7071 20.7071L23.4142 17L19.7071 13.2929Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MenuLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18V16H16V18H3ZM3 13V11H13V13H3ZM3 8V6H16V8H3ZM19.6 17L14.6 12L19.6 7L21 8.4L17.4 12L21 15.6L19.6 17Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MenuRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 6L21 8L8 8L8 6L21 6ZM21 11L21 13L11 13L11 11L21 11ZM21 16L21 18L8 18L8 16L21 16ZM4.4 7L9.4 12L4.4 17L3 15.6L6.6 12L3 8.4L4.4 7Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MessageLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 7H18V9H6V7Z" :fill="iconColor || 'black'" />
    <path d="M11 11H6V13H11V11Z" :fill="iconColor || 'black'" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 5.01185C22 3.90073 21.1046 3 20 3H4C2.89543 3 2 3.90073 2 5.01185V19.8914C2 20.8192 3.06693 21.3351 3.78716 20.7555L7.10078 18.0889H20C21.1046 18.0889 22 17.1881 22 16.077V5.01185ZM4 5.01185H20V16.077H6.39922L4 18.0078V5.01185Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Minus'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 13H4V11H20V13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'MoreVertical'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 7C10.6193 7 9.5 5.88071 9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.88071 13.3807 7 12 7ZM12 14C10.6193 14 9.5 12.8807 9.5 11.5C9.5 10.1193 10.6193 9 12 9C13.3807 9 14.5 10.1193 14.5 11.5C14.5 12.8807 13.3807 14 12 14ZM9.5 18.5C9.5 19.8807 10.6193 21 12 21C13.3807 21 14.5 19.8807 14.5 18.5C14.5 17.1193 13.3807 16 12 16C10.6193 16 9.5 17.1193 9.5 18.5Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'negative'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.4142 12L16.7071 8.70712L15.2929 7.29291L12 10.5858L8.70712 7.29291L7.29291 8.70712L10.5858 12L7.29291 15.2929L8.70712 16.7071L12 13.4142L15.2929 16.7071L16.7071 15.2929L13.4142 12Z"
      fill="#FC311E"
    />
    <path
      d="M16.7071 8.70712L13.4142 12L16.7071 15.2929L15.2929 16.7071L12 13.4142L8.70712 16.7071L7.29291 15.2929L10.5858 12L7.29291 8.70712L8.70712 7.29291L12 10.5858L15.2929 7.29291L16.7071 8.70712Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ok-filled'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#00B336"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7348 8.32172C18.1094 8.72754 18.0841 9.3602 17.6783 9.7348L10.4723 16.3865L7.29289 13.2071C6.90237 12.8166 6.90237 12.1834 7.29289 11.7929C7.68342 11.4024 8.31658 11.4024 8.70711 11.7929L10.5277 13.6135L16.3217 8.2652C16.7275 7.89059 17.3602 7.9159 17.7348 8.32172Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Pen' || iconName == 'Edit'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 1.58569L14 4.58569L15.8787 2.70701C17.0503 1.53544 18.9497 1.53544 20.1213 2.70701L21.2929 3.87859C22.4645 5.05016 22.4645 6.94965 21.2929 8.12123L7.41421 21.9999H2V16.5857L12.5858 5.99991L11 4.41412L5.70711 9.70701L4.29289 8.2928L11 1.58569ZM14 7.41412L5.63296 15.7812L8.21875 18.3669L16.5858 9.99991L14 7.41412ZM18 8.58569L19.8787 6.70701C20.2692 6.31649 20.2692 5.68332 19.8787 5.2928L18.7071 4.12123C18.3166 3.7307 17.6834 3.7307 17.2929 4.12123L15.4142 5.99991L18 8.58569ZM6.80454 19.7812L4.21875 17.1954L4 17.4141V19.9999H6.58579L6.80454 19.7812Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Phone'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7696 5.08984C13.7738 4.47827 14.2772 3.98814 14.8886 4.00022L18.7981 4.07742L19.0578 4.654C20.2564 7.31459 20.3092 10.3689 19.229 13.0852C18.693 14.433 17.8783 15.6972 16.7877 16.7877C15.6972 17.8783 14.433 18.693 13.0852 19.229C10.3689 20.3092 7.31459 20.2564 4.654 19.0578L4.07742 18.7981L4.00022 14.8886C3.98814 14.2772 4.47827 13.7738 5.08984 13.7696L9.11001 13.742C9.40366 13.74 9.68586 13.8558 9.8935 14.0634L12.9393 17.1092C13.8168 16.6838 14.6415 16.1055 15.3735 15.3735C16.1055 14.6415 16.6838 13.8168 17.1092 12.9393L14.0634 9.8935C13.8558 9.68586 13.74 9.40366 13.742 9.11001L13.7696 5.08984ZM17.8231 10.8248C18.1455 9.23256 18.0271 7.57584 17.4691 6.05156L15.7633 6.01788L15.7446 8.74623L17.8231 10.8248ZM10.8248 17.8231L8.74623 15.7446L6.01788 15.7633L6.05156 17.4691C7.57584 18.0271 9.23256 18.1455 10.8248 17.8231Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'PictureFrame'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5858 2.00009C11.3668 1.21904 12.6332 1.21905 13.4142 2.00009L16.4142 5.00009H20C21.1046 5.00009 22 5.89552 22 7.00009V20.0001C22 21.1047 21.1046 22.0001 20 22.0001H4C2.89543 22.0001 2 21.1047 2 20.0001V7.00009C2 5.89552 2.89543 5.00009 4 5.00009H7.58579L10.5858 2.00009ZM10.4142 5.00009H13.5858L12 3.41431L10.4142 5.00009ZM4 7.00009V20.0001H20V7.00009H4Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M5 17.0001L10.6 10.0001L14 14.4546L15.5 12.5455L19 17.0001H5Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Pin'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4C8.68629 4 6 6.68629 6 10C6 10.5606 6.21202 11.3125 6.64 12.218C7.05994 13.1064 7.64807 14.0608 8.30708 15.0028C9.60515 16.8582 11.121 18.5844 12 19.5414C12.879 18.5844 14.3948 16.8582 15.6929 15.0028C16.3519 14.0608 16.9401 13.1064 17.36 12.218C17.788 11.3125 18 10.5606 18 10C18 6.68629 15.3137 4 12 4ZM4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 10.9949 19.6454 12.063 19.1682 13.0726C18.6829 14.0994 18.0272 15.1552 17.3317 16.1493C15.9401 18.1383 14.3302 19.9633 13.4324 20.9385C12.6572 21.7805 11.3428 21.7805 10.5676 20.9385C9.66976 19.9633 8.05988 18.1383 6.66833 16.1493C5.97284 15.1552 5.31711 14.0994 4.83182 13.0726C4.35458 12.063 4 10.9949 4 10ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Plus'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 13V20H11V13H4V11H11V4H13V11H20V13H13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'PowerBi'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 5.72035C2 3.69643 3.96303 2.25323 5.89482 2.85691L18.8948 6.91941C20.1472 7.3108 21 8.4707 21 9.78285V17.1976C21 19.2571 18.9724 20.7042 17.0248 20.0347L16.7658 19.9457C16.2435 19.7661 15.9657 19.1972 16.1452 18.6749C16.3248 18.1526 16.8937 17.8747 17.416 18.0543L17.6749 18.1433C18.3241 18.3665 19 17.8841 19 17.1976V9.78285C19 9.34547 18.7157 8.95883 18.2983 8.82837L5.29827 4.76587C4.65434 4.56465 4 5.04571 4 5.72035V12C4 12.5523 3.55228 13 3 13C2.44772 13 2 12.5523 2 12V5.72035ZM14 9.99997C14.5523 9.99997 15 10.4477 15 11V21C15 21.5523 14.5523 22 14 22C13.4477 22 13 21.5523 13 21V11C13 10.4477 13.4477 9.99997 14 9.99997ZM11 11C11.5523 11 12 11.4477 12 12V20C12 20.5523 11.5523 21 11 21C10.4477 21 10 20.5523 10 20V12C10 11.4477 10.4477 11 11 11ZM8 12C8.55228 12 9 12.4477 9 13V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V13C7 12.4477 7.44772 12 8 12ZM5 13C5.55228 13 6 13.4477 6 14V18C6 18.5523 5.55228 19 5 19C4.44772 19 4 18.5523 4 18V14C4 13.4477 4.44772 13 5 13Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Print'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 11C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9C18.4477 9 18 9.44772 18 10C18 10.5523 18.4477 11 19 11Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 2H5V6H4C2.34315 6 1 7.34315 1 9V17H5V22H19V17H23V9C23 7.34315 21.6569 6 20 6H19V2ZM17 8H19L20 8C20.5523 8 21 8.44772 21 9V15H19V12H5V15H3V9C3 8.44772 3.44772 8 4 8L5 8H7V4H17V8ZM7 14V20H17V14H7Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Refresh'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7466 17.9568C20.1987 16.3122 21 14.1939 21 12H18.9975C18.9975 13.7057 18.3744 15.3527 17.2455 16.6314C16.1165 17.9101 14.5594 18.7323 12.8667 18.9436C11.1741 19.1549 9.46265 18.7406 8.054 17.7787C6.64535 16.8168 5.63655 15.3735 5.21725 13.7201C4.79795 12.0667 4.99701 10.3171 5.77702 8.80015C6.55703 7.2832 7.86427 6.1034 9.453 5.48253C11.0417 4.86166 12.8025 4.84247 14.4044 5.42859C15.3678 5.78109 16.2338 6.33792 16.948 7.05203L14 10H21V3L18.364 5.63603C17.4455 4.71756 16.3316 4.00137 15.0925 3.54799C13.0322 2.79415 10.7675 2.81882 8.72411 3.61737C6.68072 4.41592 4.99937 5.93336 3.99614 7.88442C2.9929 9.83548 2.73687 12.0858 3.27617 14.2124C3.81547 16.3389 5.11296 18.1953 6.92474 19.4325C8.73651 20.6696 10.9378 21.2024 13.1148 20.9307C15.2918 20.659 17.2945 19.6014 18.7466 17.9568Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Reply'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3827 3.07615C10.7564 3.23093 11 3.59557 11 4.00003V7.06484C15.3879 7.62075 20.8034 11.7377 21.9864 18.8356C22.0622 19.2904 21.8173 19.738 21.3934 19.9194C20.9696 20.1008 20.4766 19.9689 20.2 19.6C19.4711 18.6281 18.5668 17.5075 17.0527 16.6103C15.6992 15.8082 13.7957 15.1496 11 15.0223V18C11 18.4045 10.7564 18.7691 10.3827 18.9239C10.009 19.0787 9.57892 18.9931 9.29292 18.7071L1.58582 11L9.29292 3.29292C9.57892 3.00692 10.009 2.92137 10.3827 3.07615ZM4.41424 11L9.00003 15.5858V13H10C13.6492 13 16.2065 13.784 18.0723 14.8897C18.3284 15.0415 18.5699 15.1984 18.7982 15.359C16.7047 11.1319 12.7486 9.00003 10 9.00003H9.00003V6.41424L4.41424 11Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'ReplyAll'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.8407 5.08187C13.2071 5.24001 13.4445 5.60091 13.4445 6.00002V8.00934C16.8906 8.51897 21.0575 11.5802 21.9848 16.826C22.0644 17.2765 21.8281 17.7237 21.4109 17.9117C20.9938 18.0997 20.5023 17.9806 20.2174 17.6225C19.658 16.9193 18.9782 16.1264 17.8387 15.4897C16.8545 14.9398 15.4706 14.4764 13.4445 14.361V16.2667C13.4445 16.6658 13.2071 17.0267 12.8407 17.1848C12.4742 17.343 12.0489 17.2681 11.7585 16.9943L5.54233 11.1334L11.7585 5.27243C12.0489 4.99863 12.4742 4.92373 12.8407 5.08187ZM8.70714 5.29292C9.09766 5.68344 9.09766 6.31661 8.70714 6.70713L4.41424 11L8.70714 15.2929C9.09766 15.6834 9.09766 16.3166 8.70714 16.7071C8.31661 17.0977 7.68345 17.0977 7.29292 16.7071L1.58582 11L7.29292 5.29292C7.68345 4.90239 8.31661 4.90239 8.70714 5.29292ZM8.45773 11.1334L11.4445 13.9494V12.3334H12.4445C15.1661 12.3334 17.1277 12.8577 18.5922 13.6237C16.9369 11.1754 14.3214 9.93336 12.4445 9.93336H11.4445V8.31728L8.45773 11.1334Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SandClock'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 3C6 2.44772 6.44772 2 7 2H17C17.5523 2 18 2.44772 18 3V5.92893C18 7.25501 17.4732 8.52678 16.5355 9.46447L14.7071 11.2929C14.3166 11.6834 14.3166 12.3166 14.7071 12.7071L16.5355 14.5355C17.4732 15.4732 18 16.745 18 18.0711V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18.0711C6 16.745 6.52678 15.4732 7.46447 14.5355L9.29289 12.7071C9.68342 12.3166 9.68342 11.6834 9.29289 11.2929L7.46446 9.46447C6.52678 8.52678 6 7.25501 6 5.92893V3ZM8 5.92893V4H16V5.92893C16 6.72458 15.6839 7.48764 15.1213 8.05025L13.2929 9.87868C12.1213 11.0503 12.1213 12.9497 13.2929 14.1213L15.1213 15.9497C15.6839 16.5124 16 17.2754 16 18.0711V20H15.9954C15.9603 19.9603 15.9213 19.9223 15.8781 19.8863L12.6402 17.188C12.2693 16.879 11.7307 16.879 11.3598 17.188L8.12187 19.8863C8.07871 19.9223 8.03968 19.9603 8.00463 20H8V18.0711C8 17.2754 8.31607 16.5124 8.87868 15.9497L10.7071 14.1213C11.8787 12.9497 11.8787 11.0503 10.7071 9.87868L8.87868 8.05025C8.31607 7.48764 8 6.72458 8 5.92893Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Scenario'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 5H19V8H16V5ZM21 3V10H14V3H21Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 10H8V13H5V10ZM10 8V15H3V8H10Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 16H19V19H16V16ZM21 14V21H14V14H21Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 7H13V5H6V7.5H8V7Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16.0012H13V18.0012H6V15.5012H8V16.0012Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'School'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3.8208L21.8868 10H22V16H20V11.1793L19 11.8043V16.5543L12 20.9293L4.99996 16.5543V11.8043L2.11316 10L12 3.8208ZM17 13.0543V15.4458L12 18.5708L6.99996 15.4458V13.0543L12 16.1793L17 13.0543ZM5.88675 10L12 13.8208L18.1132 10L12 6.1793L5.88675 10Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Search'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9056 16.3199C13.5509 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3198 14.9057L21.7071 20.293L20.2928 21.7072L14.9056 16.3199ZM16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SearchDocument'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V10.5H18L18 9H13V4L6 4L6 20H10V22H6C4.89543 22 4 21.1046 4 20L4 4C4 2.89543 4.89543 2 6 2L14 2C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289ZM15 5.41421V7H16.5858L15 5.41421Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.0333 13C13.3581 13 12 14.3581 12 16.0333C12 17.7086 13.3581 19.0667 15.0333 19.0667C16.7086 19.0667 18.0667 17.7086 18.0667 16.0333C18.0667 14.3581 16.7086 13 15.0333 13ZM10 16.0333C10 13.2535 12.2535 11 15.0333 11C17.8132 11 20.0667 13.2535 20.0667 16.0333C20.0667 17.0616 19.7583 18.0179 19.229 18.8148L22.7071 22.2929L21.2929 23.7071L17.8148 20.229C17.0179 20.7583 16.0616 21.0667 15.0333 21.0667C12.2535 21.0667 10 18.8132 10 16.0333Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Send'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.53259 2.25342L21.4061 11.0861V12.9137L1.53259 21.7464L3.96922 11.9999L1.53259 2.25342ZM5.78077 12.9999L4.46739 18.2534L16.2878 12.9999H5.78077ZM16.2878 10.9999H5.78077L4.46739 5.74641L16.2878 10.9999Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Settings'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.75848 2L9.04705 4.1343C8.87058 4.20057 8.69697 4.27259 8.52644 4.35012L6.51387 3.34384L3.34388 6.51382L4.35015 8.52636C4.27261 8.69692 4.20058 8.87056 4.1343 9.04705L2 9.75848V14.2415L4.1343 14.953C4.20058 15.1294 4.27261 15.3031 4.35016 15.4736L3.34394 17.4861L6.51393 20.6561L8.52636 19.6498C8.69692 19.7274 8.87056 19.7994 9.04705 19.8657L9.75848 22H14.2415L14.953 19.8657C15.1295 19.7994 15.3032 19.7274 15.4737 19.6498L17.486 20.6559L20.656 17.4859L19.6498 15.4737C19.7274 15.3031 19.7994 15.1295 19.8657 14.953L22 14.2415V9.75848L19.8657 9.04705C19.7994 8.87056 19.7274 8.69692 19.6498 8.52636L20.6561 6.51392L17.4861 3.34394L15.4736 4.35016C15.3031 4.27261 15.1294 4.20058 14.953 4.1343L14.2415 2H9.75848ZM10.6167 5.74988C9.87432 5.91345 9.18029 6.20592 8.55929 6.60262L6.90878 5.77736L5.7774 6.90873L6.60265 8.55923C6.20594 9.18025 5.91346 9.87429 5.74988 10.6167L4 11.2V12.8L5.74988 13.3833C5.91346 14.1257 6.20594 14.8198 6.60266 15.4408L5.77746 17.0912L6.90883 18.2225L8.55923 17.3973C9.18024 17.7941 9.87429 18.0865 10.6167 18.2501L11.2 20H12.8L13.3833 18.2501C14.1257 18.0865 14.8198 17.794 15.4409 17.3973L17.0911 18.2224L18.2224 17.091L17.3973 15.4408C17.7941 14.8198 18.0865 14.1257 18.2501 13.3833L20 12.8V11.2L18.2501 10.6167C18.0865 9.87429 17.7941 9.18024 17.3973 8.55923L18.2225 6.90883L17.0912 5.77746L15.4408 6.60266C14.8198 6.20594 14.1257 5.91346 13.3833 5.74988L12.8 4H11.2L10.6167 5.74988Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Share'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 9C18.6569 9 20 7.65685 20 6C20 4.34315 18.6569 3 17 3C15.3431 3 14 4.34315 14 6C14 6.16224 14.0129 6.32148 14.0377 6.47674L8.00424 9.7677C7.47298 9.2904 6.7704 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C6.7704 15 7.47297 14.7096 8.00423 14.2323L14.0377 17.5233C14.0129 17.6785 14 17.8378 14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18C20 16.3431 18.6569 15 17 15C16.2296 15 15.527 15.2904 14.9958 15.7677L8.96233 12.4767C8.98712 12.3215 9 12.1622 9 12C9 11.8378 8.98712 11.6785 8.96233 11.5233L14.9958 8.23231C15.527 8.70961 16.2296 9 17 9ZM18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6ZM7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12ZM18 18C18 18.5523 17.5523 19 17 19C16.4477 19 16 18.5523 16 18C16 17.4477 16.4477 17 17 17C17.5523 17 18 17.4477 18 18Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SmallArrowDown'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9999 16.0605L5.29282 9.35344L6.70703 7.93923L11.9999 13.2321L17.2928 7.93923L18.707 9.35344L11.9999 16.0605Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SmallArrowLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.1465 6.29297L15.5607 7.70718L11.2678 12.0001L15.5607 16.293L14.1465 17.7072L8.43935 12.0001L14.1465 6.29297Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SmallArrowRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.85354 17.7073L8.43933 16.2931L12.7322 12.0002L8.43933 7.70728L9.85354 6.29306L15.5607 12.0002L9.85354 17.7073Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SmallArrowUp'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0001 7.93945L18.7072 14.6466L17.293 16.0608L12.0001 10.7679L6.70718 16.0608L5.29297 14.6466L12.0001 7.93945Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SortDoubleSmallArrowLeft'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0022 7L7.0022 12L12.0022 17V14.0043L9.99792 12L12.0022 9.99573V7Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M11.9979 12L16.9979 7V17L11.9979 12Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'SortDoubleSmallArrowRight'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9979 17L16.9979 12L11.9979 7V9.99573L14.0022 12L11.9979 14.0043V17Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M12.0022 12L7.0022 17V7L12.0022 12Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'superjob'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#00AA87"
    />
    <path
      d="M14.0391 14.0469C14.0391 13.8281 14.0052 13.6328 13.9375 13.4609C13.875 13.2839 13.7578 13.125 13.5859 12.9844C13.4193 12.8385 13.1823 12.6979 12.875 12.5625C12.5729 12.4219 12.1823 12.276 11.7031 12.125C11.1719 11.9583 10.6771 11.7708 10.2188 11.5625C9.76042 11.3542 9.35677 11.112 9.00781 10.8359C8.66406 10.5599 8.39583 10.2422 8.20312 9.88281C8.01042 9.51823 7.91406 9.09635 7.91406 8.61719C7.91406 8.14844 8.01302 7.72135 8.21094 7.33594C8.41406 6.95052 8.70052 6.61979 9.07031 6.34375C9.4401 6.0625 9.875 5.84635 10.375 5.69531C10.8802 5.54427 11.4375 5.46875 12.0469 5.46875C12.8906 5.46875 13.6198 5.6224 14.2344 5.92969C14.8542 6.23698 15.3333 6.65365 15.6719 7.17969C16.0104 7.70573 16.1797 8.29688 16.1797 8.95312H14.0391C14.0391 8.59896 13.9635 8.28646 13.8125 8.01562C13.6667 7.74479 13.4427 7.53125 13.1406 7.375C12.8438 7.21875 12.4688 7.14062 12.0156 7.14062C11.5781 7.14062 11.2135 7.20573 10.9219 7.33594C10.6354 7.46615 10.4193 7.64323 10.2734 7.86719C10.1328 8.09115 10.0625 8.34115 10.0625 8.61719C10.0625 8.82552 10.112 9.01302 10.2109 9.17969C10.3099 9.34115 10.4583 9.49479 10.6562 9.64062C10.8542 9.78125 11.099 9.91406 11.3906 10.0391C11.6875 10.1589 12.0312 10.2786 12.4219 10.3984C13.0469 10.5859 13.5938 10.7943 14.0625 11.0234C14.5365 11.2526 14.9297 11.513 15.2422 11.8047C15.5599 12.0964 15.7969 12.4245 15.9531 12.7891C16.1146 13.1536 16.1953 13.5677 16.1953 14.0312C16.1953 14.5208 16.099 14.9583 15.9062 15.3438C15.7135 15.7292 15.4375 16.0573 15.0781 16.3281C14.7188 16.599 14.2865 16.8047 13.7812 16.9453C13.2812 17.0859 12.7214 17.1562 12.1016 17.1562C11.5495 17.1562 11.0026 17.0833 10.4609 16.9375C9.92448 16.7865 9.4375 16.5625 9 16.2656C8.5625 15.9635 8.21354 15.5833 7.95312 15.125C7.69271 14.6615 7.5625 14.1198 7.5625 13.5H9.71875C9.71875 13.8594 9.77604 14.1667 9.89062 14.4219C10.0104 14.6719 10.1771 14.8776 10.3906 15.0391C10.6094 15.1953 10.8646 15.3099 11.1562 15.3828C11.4479 15.4557 11.763 15.4922 12.1016 15.4922C12.5391 15.4922 12.8984 15.4323 13.1797 15.3125C13.4661 15.1875 13.6797 15.0156 13.8203 14.7969C13.9661 14.5781 14.0391 14.3281 14.0391 14.0469Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'TableChart'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 5V8H5V5H20ZM15 19H10V10H15V19ZM5 10H8V19H5V10ZM17 19V10H20V19H17Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'TableSort'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 10L12 5L7 10H17Z" :fill="iconColor || 'black'" />
    <path d="M7 14L12 19L17 14H7Z" :fill="iconColor || 'black'" />
  </svg>
  <svg
    v-else-if="iconName == 'TableSort2'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_27_2035" fill="white">
      <path d="M17 10L12 5L7 10H17Z" />
      <path d="M7 14L12 19L17 14H7Z" />
    </mask>
    <path
      d="M17 10V11H19.4142L17.7071 9.29289L17 10ZM12 5L12.7071 4.29289L12 3.58579L11.2929 4.29289L12 5ZM7 10L6.29289 9.29289L4.58579 11H7V10ZM7 14V13H4.58579L6.29289 14.7071L7 14ZM12 19L11.2929 19.7071L12 20.4142L12.7071 19.7071L12 19ZM17 14L17.7071 14.7071L19.4142 13H17V14ZM17.7071 9.29289L12.7071 4.29289L11.2929 5.70711L16.2929 10.7071L17.7071 9.29289ZM11.2929 4.29289L6.29289 9.29289L7.70711 10.7071L12.7071 5.70711L11.2929 4.29289ZM7 11H17V9H7V11ZM6.29289 14.7071L11.2929 19.7071L12.7071 18.2929L7.70711 13.2929L6.29289 14.7071ZM12.7071 19.7071L17.7071 14.7071L16.2929 13.2929L11.2929 18.2929L12.7071 19.7071ZM17 13H7V15H17V13Z"
      :fill="iconColor || 'black'"
      mask="url(#path-1-inside-1_27_2035)"
    />
  </svg>
  <svg
    v-else-if="iconName == 'TableSort3'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 14L12 19L17 14H7Z" :fill="iconColor || 'black'" />
  </svg>
  <svg
    v-else-if="iconName == 'Tag' || iconName == 'Tags'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 3C13.4696 3 12.9609 3.21071 12.5858 3.58579L3.58579 12.5858C2.80474 13.3668 2.80474 14.6332 3.58579 15.4142L9.17157 21C9.95262 21.781 11.219 21.781 12 21L21 12C21.3751 11.6249 21.5858 11.1162 21.5858 10.5858V5C21.5858 3.89543 20.6904 3 19.5858 3H14ZM14 5H19.5858V10.5858L10.5858 19.5858L5 14L14 5ZM17.0858 9C16.2574 9 15.5858 8.32843 15.5858 7.5C15.5858 6.67157 16.2574 6 17.0858 6C17.9142 6 18.5858 6.67157 18.5858 7.5C18.5858 8.32843 17.9142 9 17.0858 9Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Unlock'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9H15C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9V11H16.9C17.5075 11 18 11.4925 18 12.1V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V12.1C6 11.5262 6.43935 11.055 7 11.0045V9ZM8 13V18H16V13H8Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Upload'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.75L19 7H16V18H8V7H5L12 1.75ZM10 5.75V16H14V5.75L12 4.25L10 5.75ZM21 20V22H3V20H21Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'User'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0001 12C14.2092 12 16.0001 10.2091 16.0001 8C16.0001 5.79086 14.2092 4 12.0001 4C9.79091 4 8.00005 5.79086 8.00005 8C8.00005 10.2091 9.79091 12 12.0001 12ZM12.0001 14C15.3138 14 18.0001 11.3137 18.0001 8C18.0001 4.68629 15.3138 2 12.0001 2C8.68635 2 6.00005 4.68629 6.00005 8C6.00005 11.3137 8.68635 14 12.0001 14Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0001 17C8.13088 17 4.90125 19.7478 4.1601 23.3989L2.20007 23.0011C3.1267 18.4362 7.16097 15 12.0001 15C16.8391 15 20.8734 18.4362 21.8 23.0011L19.84 23.3989C19.0989 19.7478 15.8692 17 12.0001 17Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'UserPass'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
      :fill="iconColor || 'black'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 2C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2L11 2V1L13 1L13 2L18 2ZM11 4V4.5C11 5.05229 11.4477 5.5 12 5.5C12.5523 5.5 13 5.05229 13 4.5V4L18 4L18 20H17.7546C16.9141 17.6603 14.6464 16 12 16C9.3535 16 7.08583 17.6603 6.24529 20H6L6 4L11 4ZM8.44681 20H15.5531C14.8466 18.8097 13.5258 18 12 18C10.4741 18 9.15338 18.8097 8.44681 20Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Users'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 8C14 10.7614 11.7614 13 9 13C6.23858 13 4 10.7614 4 8C4 5.23858 6.23858 3 9 3C11.7614 3 14 5.23858 14 8ZM12 8C12 9.65685 10.6569 11 9 11C7.34315 11 6 9.65685 6 8C6 6.34315 7.34315 5 9 5C10.6569 5 12 6.34315 12 8Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'reply'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 11C22 13.2091 20.2091 15 18 15C15.7909 15 14 13.2091 14 11C14 8.79086 15.7909 7 18 7C20.2091 7 22 8.79086 22 11ZM20 11C20 12.1046 19.1046 13 18 13C16.8954 13 16 12.1046 16 11C16 9.89543 16.8954 9 18 9C19.1046 9 20 9.89543 20 11Z"
      :fill="iconColor || 'black'"
    />
    <path
      d="M9.00001 16C5.47254 16 2.62175 18.2951 1.97646 21.2157L0.0235596 20.7843C0.891001 16.8581 4.62882 14 9.00001 14C11.5268 14 13.842 14.9551 15.5134 16.5194C16.274 16.1853 17.1161 16 18 16C20.9382 16 23.4094 18.0465 23.9792 20.7972L22.0208 21.2028C21.6451 19.389 19.9985 18 18 18C17.6098 18 17.2333 18.0529 16.877 18.1515C17.39 18.95 17.7669 19.836 17.9765 20.7843L16.0236 21.2157C15.3783 18.2951 12.5275 16 9.00001 16Z"
      :fill="iconColor || 'black'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Vk'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#0077FF"
    />
    <path
      d="M7.11276 9.0508H4.80549C4.59566 9.0508 4.45835 9.27153 4.55021 9.46082C6.37056 13.2122 7.47305 15.148 9.5653 16.2317C9.86548 16.3744 10.6364 16.6597 11.3189 16.6597C12.1721 16.6597 12.6934 16.8024 12.6934 16.0415C12.6934 15.2806 12.9304 14.8051 13.3095 14.8051C13.6887 14.8051 14.7314 16.6597 15.7267 16.6597H17.9543C18.3651 16.6597 18.6652 16.2793 18.4282 15.8513C17.9385 15.1379 16.6272 13.8064 16.2481 13.2833C16.1533 13.1525 16.2101 12.8933 16.4376 12.665L16.4475 12.6541C17.2771 11.7359 17.7782 11.1814 18.4889 9.57468C18.5986 9.32676 18.4151 9.0508 18.1448 9.0508H15.5965C15.4454 9.0508 15.3088 9.14123 15.2474 9.27979C14.377 11.2425 13.4851 12.5699 13.12 12.5699C12.7408 12.5699 12.6934 12.3702 12.6934 11.381V9.43124C12.6776 9.16176 12.4564 8.67035 11.6507 8.67035C10.6543 8.67035 9.28093 8.71791 9.18614 9.14591C9.6601 9.24102 10.0748 9.38369 10.0393 10.2397C9.99186 11.381 9.98238 12.646 9.5653 12.5699C8.96357 12.3784 8.40326 11.332 7.36861 9.21141C7.32083 9.11349 7.22141 9.0508 7.11276 9.0508Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Vkrabota'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" />
    <path
      d="M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4Z"
      fill="#0077FF"
    />
    <path
      d="M2 13C2 10.7909 3.79086 9 6 9H18C20.2091 9 22 10.7909 22 13V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V13Z"
      fill="#FF6661"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 6C10.3431 6 9 7.34315 9 9H7C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9H15C15 7.34315 13.6569 6 12 6Z"
      fill="white"
    />
    <path
      d="M13 19H11V16.9871C7.78882 16.9045 4.74347 16.4253 2 15.6256V13.5362C4.97049 14.4678 8.37452 15 12 15C15.6255 15 19.0295 14.4678 22 13.5362V15.6256C19.2565 16.4253 16.2112 16.9045 13 16.9871V19Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Warning'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM11 14V6H13V14H11ZM11 16L11 18H13L13 16H11Z"
      :fill="iconColor || '#FFB70F'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'Whatsapp'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_119_2018)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.3467 3.57733C18.1286 1.35656 15.1786 0.133153 12.0358 0.131836C5.55997 0.131836 0.289637 5.4019 0.287002 11.8796C0.286212 13.9502 0.827049 15.9713 1.85525 17.7532L0.188477 23.8412L6.41667 22.2074C8.1327 23.1434 10.0647 23.6368 12.031 23.6373H12.0358C12.0355 23.6373 12.036 23.6373 12.0358 23.6373C18.5108 23.6373 23.7817 18.3667 23.7843 11.8888C23.7856 8.74967 22.5649 5.79811 20.3467 3.57733ZM7.26467 12.3071C7.11794 12.1111 6.06603 10.7154 6.06603 9.27048C6.06603 7.82553 6.82447 7.1153 7.09344 6.82157C7.36241 6.52783 7.68064 6.45434 7.87637 6.45434C8.07211 6.45434 8.2681 6.45618 8.43908 6.46461C8.61927 6.47383 8.86137 6.39612 9.09951 6.96857C9.34425 7.55629 9.93119 9.00151 10.0047 9.14825C10.0782 9.29525 10.1269 9.46648 10.0292 9.66248C9.93145 9.85821 9.88245 9.98071 9.73571 10.1522C9.58898 10.3237 9.42749 10.535 9.29525 10.6664C9.14825 10.8129 8.99519 10.9718 9.16643 11.2655C9.33766 11.5595 9.92671 12.5208 10.7995 13.2992C11.9207 14.2995 12.8667 14.6093 13.1601 14.7563C13.4536 14.9033 13.6248 14.8788 13.7961 14.6828C13.9673 14.4868 14.53 13.8256 14.7257 13.5318C14.9215 13.2381 15.1172 13.2871 15.3862 13.3848C15.6554 13.4828 17.0985 14.1931 17.392 14.3398C17.6855 14.4868 17.8812 14.5603 17.9547 14.6828C18.0282 14.8053 18.0282 15.393 17.7835 16.0788C17.5387 16.7645 16.3659 17.3904 15.8019 17.4745C15.2961 17.5501 14.6562 17.5817 13.9528 17.358C13.5266 17.2229 12.9797 17.0422 12.2792 16.7397C9.33476 15.4681 7.41167 12.5031 7.26467 12.3071Z"
        fill="#00B336"
      />
    </g>
    <defs>
      <clipPath id="clip0_119_2018">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="iconName == 'pencil'"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.1661 6.99556L3 17.1617V21H6.83833L17.0044 10.8339L15.5569 9.38636L5.99039 18.9529H5.04711V18.0096L14.6136 8.44308L13.1661 6.99556Z"
      fill="#006BC9"
    />
    <path
      d="M16.0459 7.01083L14.5984 5.56331L16.8619 3.29979C17.2616 2.90007 17.9097 2.90007 18.3094 3.29979L20.7002 5.6906C21.0999 6.09032 21.0999 6.7384 20.7002 7.13812L18.4367 9.40164L16.9892 7.95411L17.2056 7.7377L16.2623 6.79442L16.0459 7.01083Z"
      fill="#006BC9"
    />
  </svg>
  <svg
    v-else-if="iconName == 'pen_16'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 14V11L8.5 4.5L11.5 7.5L5 14H2Z" fill="#99A5B3" />
    <path
      d="M13 6L10 3L11.2929 1.70711C11.6834 1.31658 12.3166 1.31658 12.7071 1.70711L14.2929 3.29289C14.6834 3.68342 14.6834 4.31658 14.2929 4.70711L13 6Z"
      fill="#99A5B3"
    />
  </svg>
  <svg
    v-else-if="iconName == 'collapse'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" :fill="iconColor || '#E9EDF2'" />
    <rect
      x="6"
      y="15"
      width="12"
      height="2"
      rx="1"
      :fill="iconColor || '#0075DB'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'agreed-filled'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#3DB449"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7348 8.32172C18.1094 8.72754 18.0841 9.3602 17.6783 9.7348L10.4723 16.3865L7.29289 13.2071C6.90237 12.8166 6.90237 12.1834 7.29289 11.7929C7.68342 11.4024 8.31658 11.4024 8.70711 11.7929L10.5277 13.6135L16.3217 8.2652C16.7275 7.89059 17.3602 7.9159 17.7348 8.32172Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'rejected-filled'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#EE1C1C"
    />
    <path
      d="M16.7071 8.70712L13.4142 12L16.7071 15.2929L15.2929 16.7071L12 13.4142L8.70711 16.7071L7.29289 15.2929L10.5858 12L7.29289 8.70712L8.70711 7.29291L12 10.5858L15.2929 7.29291L16.7071 8.70712Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'warning-filled'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z"
      fill="#FFD338"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 6V14H13V6H11ZM11 16L11 18H13L13 16H11Z"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="iconName == 'expand'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="#E9EDF2" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 19H5C4.44772 19 4 18.5523 4 18V10C4 9.44772 4.44772 9 5 9H15C15.5523 9 16 9.44772 16 10V18C16 18.5523 15.5523 19 15 19ZM6 11H14V17H6V11Z"
      fill="#0075DB"
    />
    <path
      d="M20 6V14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14V7H9C8.44772 7 8 6.55228 8 6C8 5.44772 8.44772 5 9 5H19C19.5523 5 20 5.44772 20 6Z"
      fill="#0075DB"
    />
  </svg>
  <svg
    v-else-if="iconName == 'check-grey'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 11L8 15L17 6" stroke="#788694" stroke-width="2" />
  </svg>
  <svg
    v-else-if="iconName == 'checkbox-selected'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2ZM17.6823 9.73106C18.0861 9.35422 18.1079 8.72143 17.7311 8.31768C17.3542 7.91393 16.7214 7.89211 16.3177 8.26894L10.5714 13.6321L8.68232 11.8689C8.27857 11.4921 7.64578 11.5139 7.26894 11.9177C6.89211 12.3214 6.91393 12.9542 7.31768 13.3311L10.5714 16.3679L17.6823 9.73106Z"
      fill="#0088FF"
    />
  </svg>
  <svg
    v-else-if="iconName == 'checkbox-unselected'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="1"
      stroke="#788694"
      stroke-width="2"
    />
  </svg>
  <svg
    v-else-if="iconName == 'delete'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0002 13.4142L7.05044 18.364L5.63623 16.9498L10.586 12L5.63623 7.05026L7.05044 5.63605L12.0002 10.5858L16.9499 5.63605L18.3642 7.05026L13.4144 12L18.3642 16.9498L16.9499 18.364L12.0002 13.4142Z"
      fill="#21272C"
    />
  </svg>

  <svg
    v-else-if="iconName == 'settings'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10ZM12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
      :fill="iconColor || '#62717E'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.75848 0L7.04705 2.1343C6.87058 2.20057 6.69697 2.27259 6.52644 2.35012L4.51387 1.34384L1.34388 4.51382L2.35015 6.52636C2.27261 6.69692 2.20058 6.87056 2.1343 7.04705L0 7.75848V12.2415L2.1343 12.953C2.20058 13.1294 2.27261 13.3031 2.35016 13.4736L1.34394 15.4861L4.51393 18.6561L6.52636 17.6498C6.69692 17.7274 6.87056 17.7994 7.04705 17.8657L7.75848 20H12.2415L12.953 17.8657C13.1295 17.7994 13.3032 17.7274 13.4737 17.6498L15.486 18.6559L18.656 15.4859L17.6498 13.4737C17.7274 13.3031 17.7994 13.1295 17.8657 12.953L20 12.2415V7.75848L17.8657 7.04705C17.7994 6.87056 17.7274 6.69692 17.6498 6.52636L18.6561 4.51392L15.4861 1.34394L13.4736 2.35016C13.3031 2.27261 13.1294 2.20058 12.953 2.1343L12.2415 0H7.75848ZM8.6167 3.74988C7.87432 3.91345 7.18029 4.20592 6.55929 4.60262L4.90878 3.77736L3.7774 4.90873L4.60265 6.55923C4.20594 7.18025 3.91346 7.87429 3.74988 8.6167L2 9.2V10.8L3.74988 11.3833C3.91346 12.1257 4.20594 12.8198 4.60266 13.4408L3.77746 15.0912L4.90883 16.2225L6.55923 15.3973C7.18024 15.7941 7.87429 16.0865 8.6167 16.2501L9.2 18H10.8L11.3833 16.2501C12.1257 16.0865 12.8198 15.794 13.4409 15.3973L15.0911 16.2224L16.2224 15.091L15.3973 13.4408C15.7941 12.8198 16.0865 12.1257 16.2501 11.3833L18 10.8V9.2L16.2501 8.6167C16.0865 7.87429 15.7941 7.18024 15.3973 6.55923L16.2225 4.90883L15.0912 3.77746L13.4408 4.60266C12.8198 4.20594 12.1257 3.91346 11.3833 3.74988L10.8 2H9.2L8.6167 3.74988Z"
      :fill="iconColor || '#62717E'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'eye'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
      :fill="iconColor || '#62717E'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 19C17.0784 19 21.3988 16.0782 23 12C21.3988 7.92183 17.0784 5 12 5C6.92156 5 2.60118 7.92183 1 12C2.60118 16.0782 6.92156 19 12 19ZM12 17C7.99829 17 4.68044 14.8784 3.19322 12C4.68044 9.12161 7.99829 7 12 7C16.0017 7 19.3196 9.12161 20.8068 12C19.3196 14.8784 16.0017 17 12 17Z"
      :fill="iconColor || '#62717E'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'delete-trash'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.44721 3.10557L8 4H5C4.44772 4 4 4.44772 4 5V6H20V5C20 4.44772 19.5523 4 19 4H16L15.5528 3.10557C15.5348 3.06967 15.5159 3.03447 15.496 3C15.1404 2.38385 14.4813 2 13.7639 2H10.2361C9.51866 2 8.85957 2.38385 8.504 3C8.48411 3.03447 8.46516 3.06967 8.44721 3.10557Z"
      :fill="iconColor || '#62717E'"
    />
    <path
      d="M14.2929 18.7071L12 16.4142L9.70711 18.7071L8.29289 17.2929L10.5858 15L8.29289 12.7071L9.70711 11.2929L12 13.5858L14.2929 11.2929L15.7071 12.7071L13.4142 15L15.7071 17.2929L14.2929 18.7071Z"
      :fill="iconColor || '#62717E'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 20V8H19V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20ZM7 20V10H17V20H7Z"
      :fill="iconColor || '#62717E'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'success'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="#00B336"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7348 8.32172C18.1094 8.72754 18.0841 9.3602 17.6783 9.7348L10.4723 16.3865L7.29289 13.2071C6.90237 12.8166 6.90237 12.1834 7.29289 11.7929C7.68342 11.4024 8.31658 11.4024 8.70711 11.7929L10.5277 13.6135L16.3217 8.2652C16.7275 7.89059 17.3602 7.9159 17.7348 8.32172Z"
      fill="white"
    />
  </svg>

  <svg
    v-else-if="iconName == 'error'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.4142 12L16.7071 8.70712L15.2929 7.29291L12 10.5858L8.70712 7.29291L7.29291 8.70712L10.5858 12L7.29291 15.2929L8.70712 16.7071L12 13.4142L15.2929 16.7071L16.7071 15.2929L13.4142 12Z"
      fill="#FC311E"
    />
    <path
      d="M16.7071 8.70712L13.4142 12L16.7071 15.2929L15.2929 16.7071L12 13.4142L8.70712 16.7071L7.29291 15.2929L10.5858 12L7.29291 8.70712L8.70712 7.29291L12 10.5858L15.2929 7.29291L16.7071 8.70712Z"
      fill="white"
    />
  </svg>

  <svg
    v-else-if="iconName == 'mass-actions'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.70712 4.70706L6.29291 3.29285L4.00001 5.58574L3.20712 4.79285L1.79291 6.20706L4.00001 8.41417L7.70712 4.70706Z"
      :fill="iconColor || 'white'"
    />
    <path
      d="M7.70712 10.7071L6.29291 9.29285L4.00001 11.5857L3.20712 10.7928L1.79291 12.2071L4.00001 14.4142L7.70712 10.7071Z"
      :fill="iconColor || 'white'"
    />
    <path
      d="M6.29291 15.2928L7.70712 16.7071L4.00001 20.4142L1.79291 18.2071L3.20712 16.7928L4.00001 17.5857L6.29291 15.2928Z"
      :fill="iconColor || 'white'"
    />
    <path
      d="M22 4.99995H9.00001V6.99995H22V4.99995Z"
      :fill="iconColor || 'white'"
    />
    <path d="M9.00001 11H22V13H9.00001V11Z" :fill="iconColor || 'white'" />
    <path d="M22 17H9.00001V19H22V17Z" :fill="iconColor || 'white'" />
  </svg>

  <svg
    v-else-if="iconName == 'done'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6783 9.7348C18.0841 9.3602 18.1094 8.72754 17.7348 8.32172C17.3602 7.9159 16.7275 7.89059 16.3217 8.2652L10.5277 13.6135L8.70711 11.7929C8.31658 11.4024 7.68342 11.4024 7.29289 11.7929C6.90237 12.1834 6.90237 12.8166 7.29289 13.2071L10.4723 16.3865L17.6783 9.7348Z"
      fill="#3DB449"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
      fill="#3DB449"
    />
  </svg>
  <svg
    v-else-if="iconName == 'sandClock'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 3C6 2.44772 6.44772 2 7 2H17C17.5523 2 18 2.44772 18 3V5.92893C18 7.25501 17.4732 8.52678 16.5355 9.46447L14.7071 11.2929C14.3166 11.6834 14.3166 12.3166 14.7071 12.7071L16.5355 14.5355C17.4732 15.4732 18 16.745 18 18.0711V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V18.0711C6 16.745 6.52678 15.4732 7.46447 14.5355L9.29289 12.7071C9.68342 12.3166 9.68342 11.6834 9.29289 11.2929L7.46446 9.46447C6.52678 8.52678 6 7.25501 6 5.92893V3ZM8 5.92893V4H16V5.92893C16 6.72458 15.6839 7.48764 15.1213 8.05025L13.2929 9.87868C12.1213 11.0503 12.1213 12.9497 13.2929 14.1213L15.1213 15.9497C15.6839 16.5124 16 17.2754 16 18.0711V20H15.9954C15.9603 19.9603 15.9213 19.9223 15.8781 19.8863L12.6402 17.188C12.2693 16.879 11.7307 16.879 11.3598 17.188L8.12187 19.8863C8.07871 19.9223 8.03968 19.9603 8.00463 20H8V18.0711C8 17.2754 8.31607 16.5124 8.87868 15.9497L10.7071 14.1213C11.8787 12.9497 11.8787 11.0503 10.7071 9.87868L8.87868 8.05025C8.31607 7.48764 8 6.72458 8 5.92893Z"
      fill="#FBA628"
    />
  </svg>
  <svg
    v-else-if="iconName == 'questionMark'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0348 7.49829C10.7769 7.49829 9.68835 8.4845 9.68835 9.79889H7.68835C7.68835 7.28566 9.769 5.49829 12.0348 5.49829C14.3288 5.49829 16.3094 7.31299 16.3094 9.79889C16.3094 10.8843 15.8307 11.6072 15.277 12.1761C15.0623 12.3967 14.8182 12.6123 14.596 12.8084C14.5542 12.8453 14.5131 12.8816 14.4732 12.9171C14.2076 13.153 13.9549 13.3851 13.7129 13.6526C13.5073 13.8799 13.3299 14.2057 13.2039 14.5526C13.0741 14.9097 13.0348 15.1884 13.0348 15.2804H11.0348C11.0348 14.8812 11.1449 14.3629 11.3241 13.8697C11.5069 13.3663 11.7979 12.7883 12.2298 12.3108C12.5478 11.9594 12.8673 11.6684 13.1451 11.4217C13.1946 11.3777 13.242 11.3358 13.2875 11.2956C13.5097 11.0991 13.6865 10.9428 13.8437 10.7813C14.179 10.4366 14.3094 10.187 14.3094 9.79889C14.3094 8.45717 13.2643 7.49829 12.0348 7.49829ZM11.0348 18.5V16.5H13.0348V18.5H11.0348ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      fill="#B3BDC6"
    />
  </svg>
  <svg
    v-else-if="iconName == 'upload'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5 3H17.5L21 7.66667V21H3V7.66667L6.5 3ZM5 9V19H19V9H5ZM16 5H8V7H16V5ZM13 11V14H15.4142L12 17.4142L8.58579 14H11L11 11H13Z"
      :fill="iconColor || '#0075DB'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'info-grey'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11 6V14H13V6H11Z" fill="#788694" />
    <path d="M11 16L11 18H13L13 16H11Z" fill="#788694" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      fill="#788694"
    />
  </svg>
  <svg
    v-else-if="iconName == 'warning-sz-18'"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.25 4.5V10.5H9.75V4.5H8.25Z" fill="#FFB70F" />
    <path d="M8.25 12L8.25 13.5H9.75L9.75 12H8.25Z" fill="#FFB70F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9ZM15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z"
      fill="#FFB70F"
    />
  </svg>
  <svg
    v-else-if="iconName == 'addUser'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9991 4C9.79001 4 7.99915 5.79086 7.99915 8C7.99915 10.2091 9.79001 12 11.9991 12V14C8.68544 14 5.99915 11.3137 5.99915 8C5.99915 4.68629 8.68544 2 11.9991 2C13.0903 2 14.1163 2.29221 14.9999 2.80331L13.9984 4.53452C13.4111 4.19477 12.7294 4 11.9991 4Z"
      fill="#0088FF"
    />
    <path
      d="M11.9992 17C8.13003 17 4.90039 19.7478 4.15925 23.3989L2.19922 23.0011C3.12584 18.4362 7.16012 15 11.9992 15C16.8383 15 20.8726 18.4362 21.7992 23.0011L19.8392 23.3989C19.098 19.7478 15.8684 17 11.9992 17Z"
      fill="#0088FF"
    />
    <path
      d="M17.9991 4V8H21.9991V10H17.9991V14H15.9991V10H11.9991V8H15.9991V4H17.9991Z"
      fill="#0088FF"
    />
  </svg>
  <svg
    v-else-if="iconName == 'oms_call'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11_1434)">
      <circle cx="12" cy="12" r="12" fill="#D6ECFF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4747 6.24145C13.4782 5.73181 13.8977 5.32337 14.4072 5.33343L17.6651 5.39777L17.8816 5.87826C18.8804 8.09541 18.9243 10.6407 18.0242 12.9042C17.5775 14.0275 16.8986 15.0809 15.9898 15.9897C15.081 16.8985 14.0276 17.5774 12.9044 18.0241C10.6408 18.9242 8.09553 18.8802 5.87838 17.8815L5.39789 17.665L5.33356 14.4071C5.32349 13.8976 5.73193 13.4781 6.24157 13.4746L9.59171 13.4516C9.83642 13.4499 10.0716 13.5464 10.2446 13.7194L12.7828 16.2576C13.5141 15.9031 14.2013 15.4212 14.8113 14.8112C15.4213 14.2012 15.9032 13.5139 16.2577 12.7827L13.7195 10.2445C13.5465 10.0715 13.45 9.8363 13.4517 9.59159L13.4747 6.24145ZM16.8526 11.0206C17.1213 9.69372 17.0226 8.31312 16.5577 7.04289L15.1361 7.01482L15.1205 9.28845L16.8526 11.0206ZM11.0207 16.8525L9.28857 15.1204L7.01494 15.136L7.04301 16.5575C8.31324 17.0225 9.69384 17.1212 11.0207 16.8525Z"
        fill="#0075DB"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_1434">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="iconName == 'allDoneMark'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 12L8.5 16.5M11.5 12.5L16 8M8 12L12 16L20 8"
      :stroke="iconColor || '#0075DB'"
      stroke-width="2"
    />
  </svg>
  <svg
    v-else-if="iconName == 'google'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.0001 12C22.0001 14.5991 21.0085 16.9666 19.383 18.7449L17.0518 16.8456C17.778 16.0888 18.3357 15.1691 18.6648 14.1468H13.8154V11.2692H21.9738C21.9912 11.5105 22.0001 11.7542 22.0001 12Z"
      fill="#4887F8"
    />
    <path
      d="M5 12C5 10.5127 5.46381 9.13383 6.25469 8L3.91867 6.10883C2.71211 7.76111 2 9.79739 2 12C2 13.6552 2.40212 15.2164 3.114 16.5914L5.67363 15C5.24169 14.0907 5 13.0736 5 12Z"
      fill="#FABC06"
    />
    <path
      d="M12.0003 19C9.20787 19 6.7971 17.3649 5.67363 15L3.114 16.5914C4.77747 19.8043 8.13258 22 12.0003 22C14.924 22 17.5545 20.7452 19.383 18.7449L17.0518 16.8456C15.7779 18.1734 13.9857 19 12.0003 19Z"
      fill="#34A853"
    />
    <path
      d="M6.25469 8C7.51964 6.18651 9.62169 5 12.0004 5C14.1529 5 16.0785 5.97153 17.3625 7.5C17.3872 7.52941 17.4117 7.55902 17.4359 7.58883L19.5557 5.44863C17.7222 3.33599 15.0174 2 12.0004 2C8.6628 2 5.70708 3.63513 3.89062 6.14802L6.25469 8Z"
      fill="#EA4235"
    />
  </svg>
  <svg
    v-else-if="iconName == 'bellsWithDot'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 10C6 7.027 8.16229 4.55904 11 4.08296V2H13V4.08296C15.8377 4.55904 18 7.027 18 10V13.6972L19.8321 16.4453C20.0366 16.7522 20.0557 17.1467 19.8817 17.4719C19.7077 17.797 19.3688 18 19 18H5C4.63121 18 4.29235 17.797 4.11833 17.4719C3.94431 17.1467 3.96338 16.7522 4.16795 16.4453L6 13.6972V10ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V14C16 14.1974 16.0584 14.3904 16.168 14.5547L17.1315 16H6.86852L7.83205 14.5547C7.94156 14.3904 8 14.1974 8 14V10Z"
      :fill="iconColor || '#788694'"
    />
    <path
      d="M14 19C13.9999 20.1045 13.1045 21 12 21C10.8954 21 9.99997 20.1045 9.99997 19H14Z"
      :fill="iconColor || '#788694'"
    />
    <circle cx="21" cy="3" r="3" fill="#0075DB" />
  </svg>
  <svg
    v-else-if="iconName === 'Id'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.46032 4C8.95674 4 8.53172 4.37446 8.46828 4.87403L8.11895 7.625H5C4.44771 7.625 4 8.07272 4 8.625C4 9.17728 4.44772 9.625 5 9.625H7.86499L7.26181 14.375H5C4.44772 14.375 4 14.8227 4 15.375C4 15.9273 4.44772 16.375 5 16.375H7.00784L6.69051 18.874C6.61464 19.4715 7.08026 20 7.68254 20C8.18612 20 8.61114 19.6255 8.67457 19.126L9.0239 16.375H13.865L13.5476 18.874C13.4718 19.4715 13.9374 20 14.5397 20C15.0433 20 15.4683 19.6255 15.5317 19.126L15.881 16.375H19C19.5523 16.375 20 15.9273 20 15.375C20 14.8227 19.5523 14.375 19 14.375H16.135L16.7382 9.625H19C19.5523 9.625 20 9.17728 20 8.625C20 8.07272 19.5523 7.625 19 7.625H16.9922L17.3095 5.12597C17.3854 4.52849 16.9197 4 16.3175 4C15.8139 4 15.3889 4.37446 15.3254 4.87403L14.9761 7.625H10.135L10.4524 5.12597C10.5282 4.52849 10.0626 4 9.46032 4ZM9.27787 14.375L9.88105 9.625H14.7221L14.119 14.375H9.27787Z"
      :fill="iconColor || '#788694'"
    />
  </svg>
  <svg
    v-else-if="iconName == 'oms-call'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_5102)">
      <circle cx="12" cy="12" r="12" fill="#D6ECFF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4747 6.24154C13.4782 5.7319 13.8977 5.32346 14.4072 5.33353L17.6651 5.39786L17.8816 5.87835C18.8804 8.0955 18.9243 10.6408 18.0242 12.9043C17.5775 14.0275 16.8986 15.081 15.9898 15.9898C15.081 16.8986 14.0276 17.5775 12.9044 18.0242C10.6408 18.9243 8.09553 18.8803 5.87838 17.8815L5.39789 17.6651L5.33356 14.4072C5.32349 13.8976 5.73193 13.4782 6.24157 13.4747L9.59171 13.4517C9.83642 13.45 10.0716 13.5465 10.2446 13.7195L12.7828 16.2577C13.5141 15.9031 14.2013 15.4213 14.8113 14.8113C15.4213 14.2012 15.9032 13.514 16.2577 12.7828L13.7195 10.2446C13.5465 10.0716 13.45 9.83639 13.4517 9.59168L13.4747 6.24154ZM16.8526 11.0206C17.1213 9.69381 17.0226 8.31321 16.5577 7.04298L15.1361 7.01491L15.1205 9.28854L16.8526 11.0206ZM11.0207 16.8526L9.28857 15.1205L7.01494 15.1361L7.04301 16.5576C8.31324 17.0226 9.69384 17.1213 11.0207 16.8526Z"
        fill="#0075DB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_5102">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      default: 'Icon'
    },
    iconColor: {
      default: ''
    },
    disabledColor: {
      default: '#cdd4da'
    },
    disabled: Boolean
  }
};
</script>
